import React, {Component} from 'react'

class Navbar extends Component {
    render() {
        return (
            <div className="navbar">
                <div className="navLinks">
                    <div className="navLink">
                        <a href="/#subjects"> <i className="fas fa-atom" /> Subjects </a>
                    </div>
                    <div className="navLink">
                        <a href="/#lessons"> <i className="fas fa-chalkboard-teacher" /> Lessons </a>
                    </div>
                    <div className="navLink">
                        <a href="/#tutors"> <i className="fas fa-users" /> Tutors </a>
                    </div>
                    <div className="navLink">
                        <a href="/#testimonials"> <i className="far fa-smile-beam" /> Testimonials </a>
                    </div>
                    <div className="navLink">
                        <a href="/#contact"> <i className="fas fa-envelope-open-text" /> Contact Us </a>
                    </div>
                </div>
            </div>
        )
    }
}

export default Navbar